import { initialState } from './reducers'

export const select = (state) => state || initialState

export const selectPrepositionState = (state) =>
    select(state).preposition?.prepositionState
